import {
  MenuItem,
  NavMenuPosition,
  PortalConfigOutputDto,
  queryNavMenusReq,
  queryPortalConfigReq
} from '@/api/menu'

export const useNavMeusStore = defineStore('navMeus', () => {
  const headerNavMenus = ref<MenuItem[]>([])
  const footerNavMenus = ref<MenuItem[]>([])
  const configs = ref<PortalConfigOutputDto[]>([])
  const copyRight = ref<PortalConfigOutputDto>()

  const refreshNavMenus = async () => {
    return Promise.all([
      queryNavMenusReq(NavMenuPosition.Header),
      queryNavMenusReq(NavMenuPosition.Footer),
      queryPortalConfigReq('footer'),
      queryPortalConfigReq('copyRight')
    ]).then(([headerMenus, footerMenus, configRes, configRes2]) => {
      headerNavMenus.value = headerMenus || []
      footerNavMenus.value = footerMenus || []
      configs.value = configRes.data.result.configList || []
      copyRight.value = configRes2.data.result.configList[0] || {}
    })
  }
  return {
    headerNavMenus,
    footerNavMenus,
    refreshNavMenus,
    configs,
    copyRight
  }
})
